"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertStatusStage = void 0;
const __1 = require("..");
var AlertStatusStage;
(function (AlertStatusStage) {
    AlertStatusStage["NEW"] = "New";
    AlertStatusStage["IN_PROGRESS"] = "InProgress";
    AlertStatusStage["IMPORTED"] = "Imported";
    AlertStatusStage["CLOSED"] = "Closed";
})(AlertStatusStage = exports.AlertStatusStage || (exports.AlertStatusStage = {}));
class AlertController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            createCase: '/v1/alert/:alertId/case',
            edit: '/v1/alert/:objectId',
            bulkEdit: '/v1/alert/_bulk',
            delete: '/v1/alert/:objectId',
            bulkDelete: '/v1/alert/delete/_bulk',
            mergeSeveralIntoCase: '/v1/alert/merge/_bulk',
            import: '/v1/alert/:alertId/import/:caseId',
            mergeIntoCase: '/alert/:alertId/merge/:caseId',
            follow: '/v1/alert/:alertId/follow',
            unfollow: '/v1/alert/:alertId/unfollow',
            read: '/v1/alert/:alertId/read',
            unread: '/v1/alert/:alertId/unread',
            unlinkFromCase: '/v1/case/:caseId/alert/:alertId',
            editCustomField: '/alert/:objectId',
            createAttachments: '/v1/alert/:alertId/attachments',
            deleteAttachment: '/v1/alert/:alertId/attachment/:attachmentId',
            downloadAttachment: '/v1/alert/:alertId/attachment/:attachmentId',
        };
    }
    /**
     * Cannot create alerts
     */
    create({}) {
        throw new Error("Can't create alerts!");
    }
    createCase(alertId, caseData) {
        return this.manager.post({ url: this.endpoints.createCase, params: { alertId } }, caseData);
    }
    mergeSeveralIntoCase({ alertIds, caseId }) {
        return this.manager.post({ url: this.endpoints.mergeSeveralIntoCase }, { alertIds, caseId });
    }
    import(alertId, caseId) {
        return this.manager.post({ url: this.endpoints.import, params: { alertId, caseId } });
    }
    mergeIntoCase({ alertId, caseId }) {
        return this.manager.post({ url: this.endpoints.mergeIntoCase, params: { alertId, caseId } });
    }
    follow(alertId) {
        return this.manager.post({ url: this.endpoints.follow, params: { alertId } });
    }
    unFollow(alertId) {
        return this.manager.post({ url: this.endpoints.unfollow, params: { alertId } });
    }
    multipleFollow(alertIds) {
        return Promise.all(alertIds.map((id) => this.follow(id)));
    }
    multipleUnfollow(alertIds) {
        return Promise.all(alertIds.map((id) => this.unFollow(id)));
    }
    bulkDelete(alertIds) {
        return this.manager.post({
            url: this.endpoints.bulkDelete,
        }, { ids: alertIds });
    }
    setCustomField(dataCustomField, objectId) {
        const { name, value, type = 'boolean' } = dataCustomField;
        const fieldsToUpdate = value !== undefined && type
            ? {
                [`customFields.${name}.${type}`]: (0, __1.formatOptionValue)(value, type),
            }
            : {
                [`customFields.${name}`]: { [type]: null, order: null },
            };
        return this.manager.patch({ url: this.endpoints.editCustomField, params: { objectId } }, fieldsToUpdate);
    }
    createAttachments(formData, alertId) {
        formData.set('canRename', 'true');
        return this.manager.post({ url: this.endpoints.createAttachments, params: { alertId } }, formData);
    }
    deleteAttachment(attachmentId, alertId) {
        return this.manager.delete({ url: this.endpoints.deleteAttachment, params: { alertId, attachmentId } });
    }
    downloadAttachment(attachmentId, alertId) {
        return this.manager.get({ url: this.endpoints.downloadAttachment, params: { alertId, attachmentId } }, { responseType: 'arraybuffer' });
    }
    unlinkFromCase(alertId, caseId) {
        return this.manager.delete({
            url: this.endpoints.unlinkFromCase,
            params: {
                alertId,
                caseId,
            },
        });
    }
}
exports.default = AlertController;
